
import { defineComponent, onMounted, computed } from 'vue'
import { useStore } from '@/store/index'

import LayoutsAuth from '@/layouts/Auth.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import HomeLatestVideos from '@/components/HomeLatestVideos.vue'
import HomeLatestWatchHistory from '@/components/HomeLatestWatchHistory.vue'
import VideoCategoryListContent from '@/components/VideoCategoryListContent.vue'
import HomeLatestNotice from '@/components/HomeLatestNotice.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    BaseAlert,
    HomeLatestVideos,
    HomeLatestWatchHistory,
    VideoCategoryListContent,
    HomeLatestNotice,
    LayoutsAuthWidth
  },
  setup() {
    const store = useStore()
    const latestVideos = computed(() => store.getters['video/getLatestVideos']())
    const latestNotices = computed(() => store.getters['notice/getLatestNotices']())
    const latestWatchHistories = computed(() => store.getters['video/getLatestWatchHistories']())
    const latestVideoCategories = computed(() => store.getters['video/getLatestVideoCategories']())

    onMounted(() => {
      Promise.allSettled([
        store.dispatch('video/fetchVideos'),
        store.dispatch('video/fetchVideoWatchHistories'),
        store.dispatch('video/fetchVideoCategories'),
        store.dispatch('notice/fetchNotices')
      ])
    })

    return {
      latestVideos,
      latestNotices,
      latestWatchHistories,
      latestVideoCategories
    }
  }
})
